import styled from 'styled-components';

export const StyledAccordionSectionContent = styled.div`
   padding: 8px 0;
`;
StyledAccordionSectionContent.displayName = 'StyledAccordionSectionContent';
